import Messenger from "./index.vue"

export default {
  path: "/messenger",
  component: Messenger,
  name: "messenger",
  meta: {
    title: "messenger.title"
  }
}
